export class Resource {
  constructor(parse) {
    this.parse = parse;
  }

  async resolve() {
    return "";
  }
}
